import { FileResponse } from "../index";

export const uploadDataFile = async (
  url: string,
  requestInit: RequestInit,
  onProgress: (progress: number) => void,
  onUploadComplete: () => void,
): Promise<FileResponse | null> => {
  const xhr = new XMLHttpRequest();
  xhr.open(requestInit.method || "POST", url);

  if (requestInit.headers) {
    for (const [key, value] of Object.entries(requestInit.headers)) {
      xhr.setRequestHeader(key, value as string);
    }
  }

  return new Promise((resolve, reject) => {
    xhr.upload.onprogress = event => {
      if (event.lengthComputable) {
        const progress = (event.loaded / event.total) * 100;
        onProgress(progress);
      }
    };

    xhr.upload.onload = () => {
      onUploadComplete();
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        const contentDisposition = xhr.getResponseHeader("Content-Disposition");
        const match =
          contentDisposition && contentDisposition.match(/filename="?(.+)"?/);
        let filename = match ? match[1].replace(/['"]/g, "") : "download";

        // If filename doesn't have an extension, add one based on Content-Type
        const hasExtension = filename.includes(".");
        if (!hasExtension) {
          const contentType = xhr.getResponseHeader("Content-Type");
          if (contentType?.includes("application/zip")) {
            filename += ".zip";
          } else if (
            contentType?.includes("spreadsheetml.sheet") ||
            contentType?.includes("vnd.openxmlformats")
          ) {
            filename += ".xlsx";
          } else if (
            contentType?.includes("excel") ||
            contentType?.includes("vnd.ms-excel")
          ) {
            filename += ".xls";
          } else if (contentType?.includes("text/csv")) {
            filename += ".csv";
          }
        }

        resolve({ blob: new Blob([xhr.response]), filename });
      } else if (xhr.status === 204) {
        // Handle 204 No Content - no file to download
        resolve(null);
      } else {
        try {
          const errorBody = JSON.parse(xhr.responseText);
          reject({ Status: xhr.status, Body: errorBody });
        } catch (e) {
          reject({ Status: xhr.status, Body: xhr.statusText });
        }
      }
    };

    xhr.onerror = () =>
      reject(new Error("Network error occurred during upload."));
    xhr.ontimeout = () => reject(new Error("Upload timed out."));

    if (requestInit.body instanceof FormData) {
      xhr.send(requestInit.body);
    } else {
      reject(new Error("The request body must be a FormData instance."));
    }
  });
};
